import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ModalComponentModule } from 'src/app/components/modal/modal.module';
import { EndTimeModalComponent } from './end-time.modal';

@NgModule({
    imports: [
        CommonModule,
        ModalComponentModule,
    ],
    declarations: [EndTimeModalComponent],
    exports: [EndTimeModalComponent]
})
export class EndTimeModalComponentModule {}
